module.exports = __webpack_public_path__ + "img/total.54a2250a.svg";